import { useFormContext, useWatch } from 'react-hook-form';

import { MealPlansMacrosFormValues } from '../../interfaces/MealPlan';
import { NUTRIENTS_ENUM } from '../../../shared/constants/NUTRIENTS_ENUM';
import { RegularMealName, WorkoutMealName } from '../../../shared/constants/mealNames';
import { calculateMealCalories } from '../../../shared/utils/mealUtils';

export const useMealCalories = (
  mealFormKey: `mealPlans.${number}.${RegularMealName}` | WorkoutMealName,
) => {
  const { control } = useFormContext<MealPlansMacrosFormValues>();

  const [proteins, carbs, fats] = useWatch({
    control,
    name: [
      `${mealFormKey}.${NUTRIENTS_ENUM.PROTEINS}`,
      `${mealFormKey}.${NUTRIENTS_ENUM.CARBS}`,
      `${mealFormKey}.${NUTRIENTS_ENUM.FATS}`,
    ] as const,
  });

  return calculateMealCalories({ proteins, carbs, fats });
};
